import React from 'react';
import { observer } from 'mobx-react';

import { Button, IconButton, Tooltip, AppBar , Box, Toolbar } from '@mui/material';
import { Home, Refresh, TextSnippet, // SettingsApplications,
         HelpOutline, ExitToApp, People } from '@mui/icons-material';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { AppStates } from './FlowStore';
import { store } from './App';
import { socketURL } from './socket';


const WhiteSpan = styled.span`
  font-family: Helvetica, serif;
  color:lightgray;
  background-color: midnightblue;
  font-weight: bold;
  font-size: 22pt;
  letter-spacing: 3px;
  padding-left: 3px;
`;

const BlueSpan = styled.span`
  font-family: Helvetica, sans-serif;
  background-color:lightgray;
  font-size: 22pt;
  letter-spacing: 3px;
  font-variant: small-caps;
  padding-left: 3px;
`;
// const ScrollingDiv = styled.div`
//   overflow: auto;
//   width: 70px; /* adjust this width depending to amount of text to display */
//   height: 80px; /* adjust height depending on number of options to display */
//   border: 1px silver solid;
// `;

//const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

const Header = observer((props) =>  {
  return (
    <AppBar position="static" elevation={0}
    sx={{display: 'flex', background: 'white', borderBottom: '1px solid gray'}}>
      <Toolbar>
        <Box sx={{display: 'inline', flexGrow: 1}}>
          <WhiteSpan>L</WhiteSpan><BlueSpan>awtomata</BlueSpan>
        </Box>
        <Box sx={{display: 'inline'}}>
          {
            store.updateAvailable ?
              <Button
                variant='outlined'
                style={{color: 'red'}}
                onClick={() => {
                  store.updateAvailable = false;
                  localStorage.clear();
                  window.location.reload();
                }}>
                Update Available
              </Button> : null
          }
          <Tooltip title="Return to dashboard, refreshing workspace">
            <NavLink to="/dashboard">
            <IconButton
              onClick={()=>{
                console.log('Going to dash', props);
                store.appState = AppStates.DASHBOARD;
                store.resetGettingResults();
                store.resetWorkspace('');
              }}
              size="large">
              <Home/>
            </IconButton>
          </NavLink>
        </Tooltip>
        <Tooltip title="Manage attorneys/clients (Beta!)">
          <NavLink to="/admin">
            <IconButton
              onClick={() => {
                store.saveState();
              }}
              size="large">
              <People />
            </IconButton>
          </NavLink>
        </Tooltip>
        <Tooltip title="Manage templates (Beta!)">
	  <NavLink to="/templates">
	    <IconButton
              onClick={() => {
                store.saveState();
              }}
              size="large">
              <TextSnippet />
            </IconButton>
	  </NavLink>
        </Tooltip>
        <Tooltip title="System help">
	  <a href="https://www.lawtomata.com/overview.html" target="_blank">
	    <IconButton size="large">
              <HelpOutline />
            </IconButton>
	  </a>
        </Tooltip>
        <Tooltip title="Refresh workspace">
	  <IconButton
            onClick={() => {
              console.log('Refreshing');
              store.refresh();
            }}
            size="large">
            <Refresh/>
          </IconButton>
        </Tooltip>
        <Tooltip title="Logout and exit">
	  <a href={socketURL + "/logout"}>
	    <IconButton
              variant='outlined'
              onClick={()=> {
                store.tenantReset();
                store.loggedIn = false;
              }}
              size="large">
              <ExitToApp />
            </IconButton>
	  </a>
        </Tooltip>
    </Box>
    </Toolbar>
    </AppBar>
  );
});

export default Header;

